





































































































































































































import { positivePass } from "@/utils/rules";
import {
  courseDetail,
  createCourse,
  editCourse,
  subjectDefaultInfo,
} from "@/api/course";
import { subjectList } from "@/api/subject";
import subjectDialog from "@/components/subjectDialog.vue";
import priceTable from "./priceTable.vue";
import richTextEditor from "@/components/richTextEditor.vue";
import imageUploader from "@/components/imageUploader.vue";
import colorSelector from "@/components/colorSelector.vue";
import { Vue, Component, Watch } from "vue-property-decorator";
@Component({
  name: "storeCourseDetail",
  components: {
    subjectDialog,
    priceTable,
    imageUploader,
    richTextEditor,
    colorSelector,
  },
})
export default class extends Vue {
  allSubjectList: any[] = [];
  form_disabled: boolean = false;
  addCourseForm: any = {
    subject_id: "",
    course_name: "",
    course_type: 1,
    absent_rule: 1,
    leave_rule: 1,
    leave_cycle: 0,
    leave_number: 0,
    icon_image: "",
    icon_image_url: "",
    cover_image: "",
    cover_image_url: "",
    detail: "",
    course_spec: [],
    color: "",
  };
  initData: any = {};
  rules: any = {
    subject_id: [{ required: true, message: "请选择科目", trigger: "change" }],
    course_name: [
      { required: true, message: "请输入课程名称", trigger: "blur" },
    ],
    course_type: [
      { required: true, message: "请选择课程类型", trigger: "change" },
    ],
    absent_rule: [],
    leave_rule: [{ required: true, message: "请选择", trigger: "change" }],
    leave_cycle: [],
    leave_number: [{ validator: positivePass, trigger: "blur" }],
    icon_image: [],
    icon_image_url: [],
    cover_image: [],
    cover_image_url: [],
    detail: [],
    course_spec: [],
    color: [{ required: true, message: "请选择课程颜色", trigger: "change" }],
  };
  @Watch("$route", { immediate: false, deep: true })
  routeQuery(oldVal: any, newVal: any) {
    const o_id = Number(oldVal.query.id);
    const n_id = Number(newVal.query.id);
    if (o_id !== n_id) {
      const id = Number(this.$route.query.id);
      if (id !== 0) {
        // 编辑
        courseDetail({ course_id: id }).then((res: any) => {
          if (res.error_code === 0) {
            this.addCourseForm = {
              course_id: res.data.course_id,
              subject_id: res.data.subject_id,
              course_name: res.data.course_name,
              course_type: res.data.course_type,
              absent_rule: res.data.absent_rule,
              leave_rule: res.data.leave_rule,
              leave_cycle: res.data.leave_cycle,
              leave_number: res.data.leave_number,
              icon_image: res.data.icon_image,
              icon_image_url: res.data.icon_image_url,
              cover_image: res.data.cover_image,
              cover_image_url: res.data.cover_image_url,
              detail: res.data.detail,
              course_spec: res.data.course_spec,
              color: res.data.color,
            };
            this.getSubjectList();
          }
        });
      } else {
        this.getSubjectList();
      }
      subjectDefaultInfo().then((res: any) => {
        if (res.error_code === 0) {
          this.initData = res.data;
        }
      });
    }
  }
  created() {
    const id = Number(this.$route.query.id);
    if (this.$route.query.type) {
      this.form_disabled = this.$route.query.type === "1";
    }
    if (id !== 0) {
      // 编辑
      courseDetail({ course_id: id }).then((res: any) => {
        if (res.error_code === 0) {
          this.addCourseForm = {
            course_id: res.data.course_id,
            subject_id: res.data.subject_id,
            course_name: res.data.course_name,
            course_type: res.data.course_type,
            absent_rule: res.data.absent_rule,
            leave_rule: res.data.leave_rule,
            leave_cycle: res.data.leave_cycle,
            leave_number: res.data.leave_number,
            icon_image: res.data.icon_image,
            icon_image_url: res.data.icon_image_url,
            cover_image: res.data.cover_image,
            cover_image_url: res.data.cover_image_url,
            detail: res.data.detail,
            course_spec: res.data.course_spec,
            color: res.data.color,
          };
          this.getSubjectList();
        }
      });
    } else {
      this.getSubjectList();
    }
    subjectDefaultInfo().then((res: any) => {
      if (res.error_code === 0) {
        this.initData = res.data;
      }
    });
  }
  getSubjectList() {
    subjectList({
      page: 1,
      page_size: 500,
      status: 1,
    }).then((res: any) => {
      if (res.error_code === 0) {
        this.allSubjectList = res.data.list;
        // 设置课程信息
        const match = res.data.list.filter((item: any) => {
          return item.subject_id === this.addCourseForm.subject_id;
        });
        if (match[0] && match[0].preset_id !== 0) {
          this.addCourseForm.icon_image = match[0].preset.icon_image;
          this.addCourseForm.icon_image_url = match[0].preset.icon_image_url;
          this.addCourseForm.cover_image = match[0].preset.cover_image;
          this.addCourseForm.cover_image_url = match[0].preset.cover_image_url;
          this.addCourseForm.detail = match[0].preset.description;
        } else {
          this.addCourseForm.icon_image = "";
          this.addCourseForm.icon_image_url = this.initData.icon_image;
          this.addCourseForm.cover_image = "";
          this.addCourseForm.cover_image_url = this.initData.cover_image;
          this.addCourseForm.detail = "";
        }
      }
    });
  }
  handleSubmit() {
    (this.$refs["mainForm"] as Vue & { validate: Function }).validate(
      (valid: boolean) => {
        if (valid) {
          const priceTable = this.$refs["priceTable"] as Vue & {
            priceTableData: any[];
          };
          const priceItems = priceTable.priceTableData;
          const pass = this.checkPriceTable();
          if (pass) {
            // 发起请求
            priceItems.map((item: any) => {
              item.quantity = String(item.quantity);
              item.price = String(item.price);
              item.unit_price = String(
                Math.ceil((item.price / item.quantity) * 100) / 100
              );
            });
            const option = { ...this.addCourseForm };
            option.course_spec = priceItems;
            delete option.cover_image_url;
            delete option.icon_image_url;
            if (this.$route.query.id === "0") {
              // 新增
              delete option.course_id;
              createCourse(option).then((res: any) => {
                if (res.error_code == 0) {
                  this.$message({
                    type: "success",
                    message: "新增成功!",
                  });
                  this.$router.push({
                    name: "storeCourse",
                  });
                } else {
                  this.$message({
                    type: "error",
                    message: "新增失败!" + res.message,
                  });
                }
              });
            } else {
              // 编辑
              editCourse(option).then((res: any) => {
                if (res.error_code == 0) {
                  this.$message({
                    type: "success",
                    message: "编辑成功!",
                  });
                } else {
                  this.$message({
                    type: "error",
                    message: "编辑失败!" + res.message,
                  });
                }
              });
            }
          }
        }
      }
    );
  }
  checkPriceTable() {
    const priceTable = this.$refs["priceTable"] as Vue & {
      priceTableData: any[];
    };
    if (!priceTable || priceTable.priceTableData.length === 0) {
      this.$message({
        type: "error",
        message: "请填写完整的课时定价信息",
      });
      return false;
    }
    let pass = true;
    let msg = "";
    priceTable.priceTableData.map((item: any) => {
      if (!item.name || !item.quantity || !item.price) {
        pass = false;
        msg = "请填写完整的课时定价信息";
      }
      if (item.quantity <= 0) {
        pass = false;
        msg = "课时数量有误";
      }
      if (item.price <= 0) {
        pass = false;
        msg = "课时总价有误";
      }
    });
    if (!pass) {
      this.$message({
        type: "error",
        message: msg,
      });
      return false;
    }
    return true;
  }
  handleSubjectChange(v: any) {
    const data = this.allSubjectList.filter((item: any) => {
      return item.subject_id === v;
    });
    if (data[0] && data[0].preset_id !== 0) {
      this.addCourseForm.icon_image = data[0].preset.icon_image;
      this.addCourseForm.icon_image_url = data[0].preset.icon_image_url;
      this.addCourseForm.cover_image = data[0].preset.cover_image;
      this.addCourseForm.cover_image_url = data[0].preset.cover_image_url;
      this.addCourseForm.detail = data[0].preset.description;
    } else {
      this.addCourseForm.icon_image = "";
      this.addCourseForm.icon_image_url = this.initData.icon_image;
      this.addCourseForm.cover_image = "";
      this.addCourseForm.cover_image_url = this.initData.cover_image;
      this.addCourseForm.detail = "";
    }
  }
}
